import type { ChoroplethView } from './types';
import type { MapAdminLevel } from '@/features/map-core/countries';
import { activeMapCountryConfig } from '@/data/active-country';

// Чистая логика выбора уровня choropleth по зуму — без зависимостей от Leaflet
// или стора, чтобы тестироваться в node-окружении без window.
//
// Уровни и их пороги зума приходят из конфига страны (2–4 уровня). У Италии их
// четыре: регионы («первое впечатление») → провинции → districts (SLL /
// comunità comprensoriali) → comuni.

/** Чистая функция выбора уровня — для тестов и для стран, отличных от активной. */
export function pickLevelForZoom(zoom: number, levels: MapAdminLevel[]): ChoroplethView {
  // От самого мелкого уровня к самому крупному: первый, чей порог достигнут.
  const ordered = [...levels].sort((a, b) => b.order - a.order);
  for (const level of ordered) {
    if (zoom >= level.zoomFrom) return level.key as ChoroplethView;
  }
  // Порог самого крупного уровня — 0, поэтому сюда попасть можно только при
  // пустом конфиге; отдаём верхний уровень как безопасный дефолт.
  return (ordered[ordered.length - 1]?.key ?? 'regions') as ChoroplethView;
}

// Сигнатура намеренно однопараметрическая: функция вызывается через
// `zooms.map(viewForZoom)`, и второй позиционный параметр поймал бы индекс.
export function viewForZoom(zoom: number): ChoroplethView {
  return pickLevelForZoom(zoom, activeMapCountryConfig().levels);
}
